import { gql } from '@apollo/client';
/**
 * @fragment DealOtherFeeFragment
 * @since 1.0.0
 */
export const DealOtherFeeFragment = gql `
  fragment DealOtherFeeFragment on DealOtherFee {
    description
    price

    fee {
      id
      title
      infos
      type
      value
      restriction
      restrictionValue
      restrictionExclusion
      locked
    }
  }
`;
